export default __webpack_public_path__ + "static/media/error-icon.df8eddf6.svg";